import {
  getGroups as getMockGroups,
  getGroup as getMockGroup,
  createGroup as createMockGroup,
  updateGroup as updateMockGroup,
  deleteGroup as deleteMockGroup,
  addWordToGroup as addMockWordToGroup,
  removeWordFromGroup as removeMockWordFromGroup,
  updateWordInGroup as updateMockWordInGroup,
} from "./vocabularyGroups.mocks";

import {
  Group,
  CreateGroupInputs,
  UpdateVocabularyGroupInputs,
  GetGroupsResponse,
  GroupsFilters,
  AddWordToGroupInputs
} from "./vocabularyGroups.interfaces";

export const getGroups = async (
  filters: GroupsFilters
): Promise<GetGroupsResponse> => {
  try {
    return await getMockGroups(filters);
  } catch (error) {
    console.error("Erro ao buscar grupos:", error);
    throw error;
  }
};

export const getGroup = async (id: string): Promise<Group> => {
  try {
    return await getMockGroup(id);
  } catch (error) {
    console.error(`Erro ao buscar grupo ${id}:`, error);
    throw error;
  }
};

export const createGroup = async (
  data: CreateGroupInputs
): Promise<string> => {
  try {
    return await createMockGroup(data);
  } catch (error) {
    console.error("Erro ao criar grupo:", error);
    throw error;
  }
};

export const updateGroup = async (
  id: string,
  data: UpdateVocabularyGroupInputs
): Promise<void> => {
  try {
    await updateMockGroup(id, data);
  } catch (error) {
    console.error(`Erro ao atualizar grupo ${id}:`, error);
    throw error;
  }
};

export const deleteGroup = async (ids: string[]): Promise<void> => {
  try {
    await deleteMockGroup(ids);
  } catch (error) {
    console.error("Erro ao excluir grupos:", error);
    throw error;
  }
};

export const addWordToVocabularyGroup = async (
  groupId: string,
  data: AddWordToGroupInputs
): Promise<void> => {
  try {
    await addMockWordToGroup(groupId, data);
  } catch (error) {
    console.error("Erro ao adicionar palavra ao grupo:", error);
    throw error;
  }
};

export const removeWordFromVocabularyGroup = async (
  groupId: string,
  wordId: string
): Promise<void> => {
  try {
    await removeMockWordFromGroup(groupId, wordId);
  } catch (error) {
    console.error("Erro ao remover palavra do grupo:", error);
    throw error;
  }
};

export const updateWordInVocabularyGroup = async (
  groupId: string,
  wordId: string,
  word: AddWordToGroupInputs
): Promise<void> => {
  try {
    // Convertendo AddWordToGroupInputs para VocabularyWord
    const vocabularyWord = {
      id: wordId,
      word: word.word,
      translation: word.translation,
      exampleSentence: word.exampleSentence
    };
    await updateMockWordInGroup(groupId, wordId, vocabularyWord);
  } catch (error) {
    console.error("Erro ao atualizar palavra no grupo:", error);
    throw error;
  }
};